<template>
  <root />
</template>

<script setup lang="ts">
import type {
  StoryblokRichTextDocumentNode,
  StoryblokRichTextNode,
  StoryblokRichTextResolvers,
} from '@storyblok/richtext'

const props = defineProps<{
  document: StoryblokRichTextDocumentNode
  resolvers?: StoryblokRichTextResolvers<VNode>
}>()

const renderedDoc = ref<StoryblokRichTextNode<VNode>>()
const root = () => renderedDoc.value

const {
  document: initialDocument,
  resolvers: initialResolvers,
} = toRefs(props)

watch([
  initialDocument,
  initialResolvers,
], ([
  document,
  resolvers,
]) => {
  const { render } = useRenderer(resolvers)

  renderedDoc.value = render(document)
}, {
  immediate: true,
})
</script>
